import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Breadcrumb } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  imports: [Breadcrumb, RouterLink, NgClass],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  protected readonly breadcrumpsService = inject(BreadcrumbService);
  protected readonly home: MenuItem = {
    icon: 'pi pi-home',
    iconStyle: { color: '#0080fb' },
    routerLink: '/',
  };
}
